import { useQuery } from '@tanstack/react-query';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { checkZipCode, getCitiesByZipCode, getCountries, getStatesByCountry } from './country.api';

export const COUNTRIES_QUERY_KEY = 'country-countries';
export const STATES_BY_COUNTRY_QUERY_KEY = 'country-states';
export const CITIES_BY_ZIP_CODE_QUERY_KEY = 'country-cities';
export const useCountries = () =>
  useQuery<ApiFnReturnType<typeof getCountries>>({
    queryKey: [COUNTRIES_QUERY_KEY],
    queryFn: getCountries,
  });

export const useStatesByCountry = (id: string) => {
  return useQuery<ApiFnReturnType<typeof getStatesByCountry>>({
    queryKey: [STATES_BY_COUNTRY_QUERY_KEY, id],
    queryFn: () => getStatesByCountry(id),
    enabled: !!id,
  });
};

export const useCitiesByZipCode = (countryCode: string, zipCode: string) =>
  useQuery<ApiFnReturnType<typeof getCitiesByZipCode>>({
    queryKey: [CITIES_BY_ZIP_CODE_QUERY_KEY, countryCode, zipCode],
    queryFn: () => getCitiesByZipCode(countryCode, zipCode),
    enabled: !!countryCode && !!zipCode,
  });

export function useCheckZipCodeQuery(countryCode: string, zipCode: string) {
  return useQuery({
    queryKey: ['check-zip-code', countryCode, zipCode],
    queryFn: () => checkZipCode(countryCode, zipCode),
    enabled: !!countryCode && !!zipCode,
  });
}
